/**
 * Reporting/Analytics Page
 * Wraps the existing Admin Analytics component in SubscriptionLayout
 */

import React from 'react';
import SubscriptionLayout from '../../components/subscription/SubscriptionLayout';
import AdminAnalytics from '../../admin/Analytics';

const ReportingPage: React.FC = () => {
  return (
    <SubscriptionLayout>
      <AdminAnalytics />
    </SubscriptionLayout>
  );
};

export default ReportingPage;


